import React, { Component } from "react";
import { Form, Button, Image, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get, isString } from "lodash";
import IconTime from "../../assets/icon-time.svg";
import {
  getColor,
  isValidArray,
  transformProjectCategoryId,
  dateFormat,
  dayAgo,
  formatNumber,
  getBackgroundColorCode,
  getColorCode,
  projectFormLabel,
  getLocalstorage
} from "../../helper";
import { PATHS, IIG_PATHS, ISSUE_STATUS } from "../../constant";
import DisplayByPermission from "../../component/DisplayByPermission";
import { Pli } from "../pliReview";
import { DisplayContent } from "../displayContent";
import { Pragati } from "../prgatiReview";
import { Nip } from "../nipReview";
import {
  MultipleTags,
  OrganizationTemplate,
  ReadMore,
  RedirectUser
} from "../reusableComponent";
import { PmFoundationStone } from "../pmFoundationStone/pmFoundationStone";
import { CmPragatiYatra } from "../cmPragatiYatra/cmPragatiYatra";
import { CmFoundationStone } from "../cmFoundationStone/cmFoundationStone";
import { PmGatiShakti } from "../pmGatiShakti/pmGatiShakti";
import { PmgsHipimage } from "../pmgsHipp/pmgsHip";
import { March24 } from "../march24";
import { iigBaseUrl } from "../../globalConfig";
import IssueSingle from "./IssueSingle";
import AgendaProjectDecision from "../agendaDetails/AgendaProjectDecision";
import ProjectAddDecisionModal from "../agendaDetails/ProjectAddDecisionModal";
import { PragatiPipeline } from "../prgatiReview/pragatiPipeline";

export class ProjectIssueSingle extends Component {
  constructor() {
    super();
    this.state = {
      showOtherPPList: false,
      displayProjectPopUp: false
    };
  }

  toggleOtherPPList = () => {
    this.setState({
      showOtherPPList: !this.state.showOtherPPList
    });
  };

  openProjectPageBasedOnLink = (includeReadMore = false) => {
    const { project } = this.props;
    const status = get(project, "status");
    const isIIGDraft = status === "CRIP_DRAFT";
    return (
      <>
        <Link
          to={{
            pathname: isIIGDraft
              ? PATHS.IIG_PROJECT_DETAIL
              : PATHS.PROJECT_DETAILS,
            search: `?projectId=${get(project, "id")}`,
            state: {
              projectId: get(project, "id"),
              isEdit: false
            }
          }}
        >
          {includeReadMore ? (
            <ReadMore
              content={get(project, "name", "NA")}
              clamp={5}
              displayExpandButtons={false}
              lineHeightTitle={1.3}
            />
          ) : (
            <> #{get(project, "displayId", "NA")}</>
          )}
        </Link>
      </>
    );
  };

  openProjectPageBasedOnCommonLink = (includeReadMore = false) => {
    const { project } = this.props;
    const iigProjectReferenceId = get(project, "iigProjectReferenceId");
    return (
      <>
        <a
          href={
            iigBaseUrl +
            IIG_PATHS.IIG_PROJECT_DETAIL +
            "?iigProject=" +
            iigProjectReferenceId
          }
          target="_blank"
        >
          {includeReadMore ? (
            <ReadMore
              content={get(project, "name", "NA")}
              clamp={5}
              displayExpandButtons={false}
            />
          ) : (
            <> #{get(project, "commonId")}</>
          )}
        </a>
      </>
    );
  };

  selectionHandler = () => {
    const {
      idx,
      selectionHandler,
      //fromCreateAgendaPage,
      fromAgendaDetailPage,
      deleteHandler
    } = this.props;
    // fromCreateAgendaPage ? deleteHandler(idx) : selectionHandler(idx);
    deleteHandler(idx);
  };

  deleteSingleIssueHandler = id => {
    const {
      idx,
      selectionHandler,
      //fromCreateAgendaPage,
      deleteIssueHandler
    } = this.props;

    // fromCreateAgendaPage ? deleteHandler(idx) : selectionHandler(idx);
    deleteIssueHandler(id);
  };

  onToggleModal = () => {
    this.setState(prevState => ({
      displayProjectPopUp: !prevState["displayProjectPopUp"]
      //viewMoreStatus: false
    }));
  };

  render() {
    const {
      project,
      fromAgendaDetailPage,
      meetingStatus,
      permission,
      agendaData,
      handleUpdateStatus,
      key,
      idx
    } = this.props;
    console.log("agendaData", agendaData);
    const { showOtherPPList, displayProjectPopUp } = this.state;
    const iigProjectCommonId = get(project, "commonId");
    const upProjectId = get(project, "upProjectId");
    const status =
      isString(get(project, "status")) &&
      get(project, "status")
        .replace(/[_]/, " ")
        .toLowerCase();
    const isIIGDraft = status === "crip draft";
    const isResolved =
      get(project, "projectStatusWithRespectToIssueStatus") === "RESOLVED";
    const projectResolutionDate = get(project, "projectResolutionDate")
      ? dateFormat(get(project, "projectResolutionDate"))
      : "NA";
    const createdBy =
      project.projectPPList && project.projectPPList.length
        ? project.projectPPList[0]
        : null;
    const projectPPList =
      project.projectPPList && project.projectPPList.length
        ? project.projectPPList
        : [];
    function getUniqueOrganizations(data) {
      // Filter out null values before creating the set
      const filteredData = data.filter(item => item.organizationGroup !== null);
      // Create a Set to store unique organization groups
      const uniqueOrgs = new Set(
        filteredData.map(item => item.organizationGroup)
      );
      // Convert the Set back to an array
      return Array.from(uniqueOrgs);
    }
    const uniqueOrganizations = getUniqueOrganizations(projectPPList);
    const organistionArr =
      projectPPList.filter(
        item => item !== null && item.organizationGroup !== ""
      ) || [];
    const projectCost = formatNumber(
      get(project, "revisedCost", 0) || get(project, "cost", "0")
    );
    let projectLocations = [];
    if (isValidArray(get(project, "locations"))) {
      // projectLocations = get(project, "locations").map((location, index) =>
      //   index < get(project, "locations").length - 1
      //     ? location.state + ", "
      //     : location.state + ""
      // );
      //console.log("project", project);
      if (
        get(project, "category") === "STATE" ||
        get(project, "sponsoredByCategory") === "STATE"
      ) {
        projectLocations = get(project, "locations")
          .map(location => {
            if (location.districtIdName.length > 0) {
              return location.districtIdName
                .map((district, districtIndex) => {
                  return district.name;
                })
                .join(", ");
            } else {
              return "-";
            }
          })
          .join(", ");
      } else {
        projectLocations = get(project, "locations").map((location, index) =>
          index < get(project, "locations").length - 1
            ? location.state + ", "
            : location.state + ""
        );
      }
    }

    let showMeetingData;
    if (fromAgendaDetailPage) {
      showMeetingData = get(project, "projectDecisions", []).find(value => {
        return agendaData.id === value.meetingId;
      });
    }
    const issuesSelectedArray = get(project, "issuesSelected", []);
    const issuesSelectedClass =
      issuesSelectedArray.length > 0 ? "has-issues" : "";
    const userInfo = getLocalstorage("user");
    const isUserStatePMG = get(userInfo, "groupCategory") === "STATE_PMG";
    const centralProject = get(project, "category", "NA") == "CENTRAL";
    return (
      <React.Fragment>
        <div
          className="project-list-box-wrapper"
          data-test="project-list-wrapper"
        >
          <div className="select-issue-wrapper agenda-project-wrapper">
            {!fromAgendaDetailPage ? (
              issuesSelectedArray.length > 0 ? (
                <form className={`select-issue-form ${issuesSelectedClass}`}>
                  <OverlayTrigger
                    placement="bottom-start"
                    overlay={
                      <Tooltip
                        id="tooltip-delete-hover"
                        placement="bottom-start"
                        className={`tooltip-delete-project ${""}`}
                        arrowProps={{ variant: false }}
                      >
                        {
                          "Deleting the project will also remove the selected issues"
                        }
                      </Tooltip>
                    }
                  >
                    <div
                      className="delete-project"
                      //title="Delete"
                      onClick={this.selectionHandler}
                    />
                  </OverlayTrigger>
                </form>
              ) : (
                <form className={`select-issue-form`}>
                  <div
                    className="delete-project"
                    //title="Delete"
                    onClick={this.selectionHandler}
                  />
                </form>
              )
            ) : (
              //check for schedule page and superadmin
              meetingStatus === "SCHEDULED" && (
                <DisplayByPermission
                  display={
                    get(permission, "updateAllAgendaSuperPMG") &&
                    !get(permission, "canViewOnlyProject")
                  }
                >
                  {issuesSelectedArray.length > 0 ? (
                    <>
                      <form
                        className={`select-issue-form ${issuesSelectedClass}`}
                      >
                        <OverlayTrigger
                          placement="bottom-start"
                          overlay={
                            <Tooltip
                              id="tooltip-delete-hover"
                              placement="bottom-start"
                              className={`tooltip-delete-project ${""}`}
                              arrowProps={{ variant: false }}
                            >
                              {
                                "Deleting the project will also remove the selected issues"
                              }
                            </Tooltip>
                          }
                        >
                          <div
                            className="delete-project"
                            //title="Delete"
                            onClick={this.selectionHandler}
                          />
                        </OverlayTrigger>
                      </form>
                    </>
                  ) : (
                    <form className={`select-issue-form`}>
                      <div
                        className="delete-project"
                        title="Delete"
                        onClick={this.selectionHandler}
                      />
                    </form>
                  )}
                </DisplayByPermission>
              )
            )}
            <div className="project-container-wrapper">
              <span className="project-count-hash">#{idx + 1}</span>
              <div className="project-container">
                <div className="project-list-box-top">
                  <div className="project-box-top-upper">
                    <div className="project-name-section">
                      <div className="d-flex flex-wrap">
                        <div>
                          {iigProjectCommonId && (
                            <div className="id-wrapper-box mr-2">
                              <p className="border-right mb-1 common-project-id">
                                COMMON PROJECT ID{" "}
                                <b className="link-color mr-2 iig-project-link-color">
                                  {this.openProjectPageBasedOnCommonLink()}
                                </b>
                              </p>
                            </div>
                          )}
                          {upProjectId && (
                            <div className="id-wrapper-box mr-2">
                              <p className="border-right mb-1 common-project-id">
                                CMIS PROJECT ID{" "}
                                <b className="link-color mr-2 iig-project-link-color">
                                  #{upProjectId}
                                </b>
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="project-id mb-2">
                          Project{" "}
                          <b data-test="project-id">
                            {this.openProjectPageBasedOnLink()}
                          </b>
                        </div>
                        {/* {projectPPList &&
                          projectPPList.map(item => {
                            if (item !== null) {
                              if (item.organizationGroup !== null) {
                                return (
                                  <OrganizationTemplate
                                    title={item.organizationGroup}
                                    classes="organisation mb-2 g"
                                  />
                                );
                              }
                            }
                          })} */}
                        {uniqueOrganizations.map((organization, index) => (
                          <OrganizationTemplate
                            key={index}
                            title={organization}
                            classes="organisation mb-2 g"
                          />
                        ))}
                        <div className="project-stage-section">
                          <div
                            className={`${getBackgroundColorCode(
                              status
                            )} project-stage-background`}
                          >
                            <span
                              className={`project-stage`}
                              data-test="project-stage"
                            >
                              {status}
                            </span>
                          </div>
                          {get(project, "terminatedDate", null) ? (
                            <div className="date-terminated">
                              <Image src={IconTime} alt="Time" />
                              <span>
                                {dateFormat(
                                  get(project, "terminatedDate", null)
                                )}
                              </span>
                            </div>
                          ) : null}
                          {isResolved ? (
                            <div className="resolution-date">
                              <div> Resolved on</div>
                              <div className="second-row">
                                <Image src={IconTime} alt="Time" />
                                <span>{projectResolutionDate}</span>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <h2 className="project-name" data-test="project name">
                        {this.openProjectPageBasedOnLink(true)}
                      </h2>
                      {get(project, "projectStatusWithRespectToIssueStatus") ||
                      get(project, "projectCompletionDTO.status") ? (
                        <div className="project-status">
                          {get(
                            project,
                            "projectStatusWithRespectToIssueStatus"
                          ) &&
                          get(
                            project,
                            "projectStatusWithRespectToIssueStatus"
                          ) !== "NO ISSUES" ? (
                            <span
                            /** className={getColorCode(
        get(project, "projectStatusWithRespectToIssueStatus")
      )} */
                            >
                              {get(
                                project,
                                "projectStatusWithRespectToIssueStatus"
                              )}
                            </span>
                          ) : null}

                          {get(project, "projectCompletionDTO.status") ? (
                            <span
                            /** className={getColorCode(
        get(project, "projectCompletionDTO.status")
      )} */
                            >
                              {get(project, "projectCompletionDTO.status") ===
                              "NO IMPLEMENTATION"
                                ? "UNDER DEVELOPMENT"
                                : get(project, "projectCompletionDTO.status")}
                            </span>
                          ) : null}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="project-box-top-lower">
                    <div className="project-details-left-section">
                      <div className="project-detail-unit display-mobile">
                        <div className="heading-text">Project Id:</div>
                        <b>{this.openProjectPageBasedOnLink()}</b>
                      </div>
                      {organistionArr && organistionArr.length ? (
                        <div className="project-detail-unit display-mobile">
                          <div className="heading-text">Organisation:</div>
                          <div>
                            {organistionArr.map((item, index) => (
                              <span>
                                {item.organizationGroup}
                                {index < organistionArr.length - 1
                                  ? ", "
                                  : ""}{" "}
                              </span>
                            ))}
                          </div>
                        </div>
                      ) : null}
                      <div className="project-detail-unit">
                        <div className="heading-title">
                          Sponsoring Ministry: &nbsp;
                        </div>
                        <span className="heading-text">
                          {get(project, "sponsoredBy")}
                        </span>
                      </div>
                      {get(project, "sponsoringDepartment") ? (
                        <div className="project-detail-unit">
                          <div className="heading-title">
                            {projectFormLabel(
                              get(project, "sponsoredByid"),
                              "department",
                              "Sponsoring Department"
                            )}
                            : &nbsp;
                          </div>
                          <span className="heading-text">
                            {get(project, "sponsoringDepartment.name")}
                          </span>
                        </div>
                      ) : null}
                      {isValidArray(get(project, "locations")) ? (
                        <div className="project-detail-unit">
                          <div className="heading-title">
                            Project Location(s): &nbsp;
                          </div>
                          <ReadMore
                            content={
                              <span className="heading-text">
                                {projectLocations}
                              </span>
                            }
                            clamp={5}
                            displayExpandButtons={false}
                          />
                        </div>
                      ) : null}

                      <div className="issues-open-resolved">
                        <div className="project-issues-details">
                          <span className="heading-title">
                            Issue(s) Open:&nbsp;
                          </span>
                          <span className="heading-text">
                            {get(project, "openIssuesCount", 0)}
                          </span>
                        </div>
                        <span
                          style={{
                            marginLeft: "10px",
                            marginRight: "10px",
                            lineHeight: "13px",
                            color: "#525252"
                          }}
                        >
                          |
                        </span>
                        <div className="project-issues-details">
                          <span className="heading-title">
                            Issue(s) Resolved:&nbsp;
                          </span>
                          <span className="heading-text">
                            {get(project, "resolvedIssuesCount", 0)}
                          </span>
                        </div>
                      </div>

                      {get(project, "projectCompletionDTO") &&
                      get(project, "projectCompletionDTO.percentage") ? (
                        <div className="physical-progress-wrapper">
                          <div className="progress-upper d-flex align-items-center fw-bold">
                            Physical Progress:{" "}
                            <span className="d-inline-block">
                              {get(project, "projectCompletionDTO.percentage")}%
                            </span>
                          </div>
                          {get(
                            project,
                            "projectCompletionDTO.physicalProgressAsOf"
                          ) ? (
                            <div className="progress-lower">
                              (as of{" "}
                              {dateFormat(
                                get(
                                  project,
                                  "projectCompletionDTO.physicalProgressAsOf"
                                )
                              )}
                              )
                            </div>
                          ) : get(project, "projectCompletionDTO.date") ? (
                            <div className="progress-lower">
                              (as of{" "}
                              {dateFormat(
                                get(project, "projectCompletionDTO.date")
                              )}
                              )
                            </div>
                          ) : null}
                        </div>
                      ) : null}
                      {fromAgendaDetailPage ? (
                        <>
                          {!showMeetingData ? (
                            get(agendaData, "meetingStatus", null) ===
                              "SCHEDULED" ||
                            (get(agendaData, "meetingStatus", null) ===
                              "CONCLUDED" &&
                              get(agendaData, "superAdminEditable")) ? (
                              <Button
                                className="add-decision-button-agenda shadow-none"
                                onClick={this.onToggleModal}
                              >
                                ADD DECISION
                              </Button>
                            ) : null
                          ) : null}

                          {/* <AgendaProjectDecision
                            agendaData={agendaData}
                            project={project}
                            handleUpdateStatus={handleUpdateStatus}
                          /> */}
                        </>
                      ) : null}
                    </div>
                    <div className="project-details-right-section">
                      <div className="project-list-box-bottom">
                        <div className="project-bottom-left">
                          <div className="d-flex tags-contatiner">
                            <Pragati
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "pragatiDTO.pragatiReview"
                              )}
                            />
                            {/* <PragatiPipeline
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "pragatiDTO.pragatiPipeline"
                              )}
                            /> */}
                            <PragatiPipeline
                              className={"pragati-review"}
                              isValidProject={
                                !get(project, "pragatiDTO.pragatiReview") &&
                                get(project, "pragatiDTO.pragatiPipeline")
                              }
                            />
                            <Nip
                              className={"pragati-review"}
                              isValidProject={get(project, "nipDTO.nipReview")}
                            />
                            <PmFoundationStone
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "pmFoundationStoneDTO.pmFoundationStone"
                              )}
                            />
                            <CmPragatiYatra
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "cmPragatiYatraDTO.cmPragatiYatra"
                              )}
                            />
                            <CmFoundationStone
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "cmFoundationStoneDTO.cmFoundationStone"
                              )}
                            />
                            <PmGatiShakti
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "pmGatiShaktiNewDTO.pmGatiShaktiNew"
                              )}
                            />
                            <PmgsHipimage
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "pmGsHipDTO.pmgsHip"
                              )}
                            />
                            <Pli
                              className={"pragati-review"}
                              isValidProject={get(project, "pliDTO.pli")}
                            />
                            <March24
                              className={"pragati-review"}
                              isValidProject={get(
                                project,
                                "march24DTO.march24"
                              )}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="project-cost-section">
                        <label>Project Cost</label>
                        <p>
                          {parseFloat(projectCost) !== 0
                            ? `₹ ${projectCost} Cr.`
                            : "N/A"}
                        </p>
                      </div>
                      <div className="project-created-date">
                        <span
                          className={`project-created-by
                                        ${
                                          createdBy && createdBy.verified
                                            ? "verified-user"
                                            : ""
                                        }
                                        `}
                        />
                        <span className="first-pp-name">
                          <RedirectUser
                            title={get(createdBy, "name", null)}
                            id={get(createdBy, "id", null)}
                            isProjectProponentDetail={true}
                            data-test="first-pp-name"
                          />
                        </span>
                        {projectPPList && projectPPList.length > 1 ? (
                          <div
                            className={`dropdown field-sort ${
                              showOtherPPList ? "visible" : ""
                            }`}
                            onClick={this.toggleOtherPPList}
                          >
                            <div
                              className={`dropdown-overlay ${
                                showOtherPPList ? "visible" : ""
                              }`}
                            />
                            <div className="dropdown-selected-value">
                              + {projectPPList.length - 1}
                            </div>
                            <div className="dropdown-option-list hidden-mobile">
                              <div className="dropdown-option-list-heading" />
                              {projectPPList
                                ? projectPPList.map((value, index) => {
                                    if (index !== 0) {
                                      return (
                                        <RedirectUser
                                          title={get(value, "name", null)}
                                          id={get(value, "id", null)}
                                          isProjectProponentDetail={true}
                                        />
                                      );
                                    }
                                  })
                                : null}
                            </div>
                          </div>
                        ) : null}
                        <span className="project-created-on">
                          {get(project, "verificationDate")
                            ? `Verified on ${dateFormat(
                                get(project, "verificationDate", null)
                              )}`
                            : `${isIIGDraft ? "Imported on" : "Created on"}
                        ${dateFormat(get(project, "createdDate", null))}`}
                        </span>
                      </div>
                    </div>
                  </div>
                  {fromAgendaDetailPage ? (
                    get(project, "projectDecisions", []).length &&
                    showMeetingData ? (
                      <AgendaProjectDecision
                        agendaData={agendaData}
                        project={project}
                        handleUpdateStatus={handleUpdateStatus}
                      />
                    ) : null
                  ) : null}
                  {/* {fromAgendaDetailPage ? (
                    <AgendaProjectDecision
                      agendaData={agendaData}
                      project={project}
                      handleUpdateStatus={handleUpdateStatus}
                    />
                  ) : null} */}
                </div>
              </div>
            </div>
          </div>
          {project.issuesSelected.map((item, index) => (
            <React.Fragment key={index}>
              <IssueSingle
                issue={item}
                project={project}
                idx={item.id}
                key={index}
                deleteHandler={this.deleteSingleIssueHandler}
                //fromCreateAgendaPage={true}
                agendaData={agendaData}
                handleUpdateStatus={handleUpdateStatus}
                meetingStatus={meetingStatus}
                permission={permission}
                fromAgendaDetailPage={fromAgendaDetailPage}
                IssueSelected="delete"
              />
              {/* <IssueSingleList
                issues={item}
                agendaData={agendaData}
                //handleUpdateStatus={this.handleUpdateStatus}
                //changeAgendaDetail={this.changeAgendaDetail}
                permission={permission}
              /> */}
            </React.Fragment>
          ))}
        </div>
        <DisplayByPermission display={displayProjectPopUp}>
          <ProjectAddDecisionModal
            displayProjectPopUp={displayProjectPopUp}
            agendaDetails={agendaData}
            project={project}
            meetingData={showMeetingData}
            handleClose={this.onToggleModal}
            handleUpdateStatus={handleUpdateStatus}
            title={!showMeetingData ? "Add" : "Edit"}
          />
        </DisplayByPermission>
      </React.Fragment>
    );
  }
}

export default ProjectIssueSingle;
